<div id="verify-confirmed-container">
  <div class="self-tour-step-header">
    <div class="text-xl font-denim-semibold">
      YOU'RE ALL SET!
    </div>
  </div>
  <p class="center-text">We have unlocked the front door of the home so you can start your tour.</p>
  <p class="center-text" style="font-weight: bold;">Note: When you are finished touring the home, please shut and re-lock all exterior doors. When exiting the front door, simply press the checkmark or Yale button located on the front door's keypad to lock the door.</p>
</div>
